import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const ChangeTransactionIdentifier = (props) => {
  const [newIdentifier, setNewIdentifier] = useState("");
  const [trNote, setTrNote] = useState(
    props.transactionsData.filter((el) => el.tr_id === props.id)[0].note
  );
  const [transaction, setTransaction] = useState(
    props.transactionsData.filter((el) => el.tr_id === props.id)[0]
  );
  const [loading, setLoading] = useState(false);
  const [transactionsData, setTransactionsData] = useState([]);
  const [transactionsNaData, setTransactionsNaData] = useState([]);

  const fetchTransactionsAss = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTransactionsData(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
      })
      .catch((error) => {});
  };

  const fetchTransactionsNAss = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsNotAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTransactionsNaData(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTransactionsAss();
    fetchTransactionsNAss();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleIdentifierChange = (e) => {
    setNewIdentifier(e.target.value.toString().toUpperCase());
  };

  const handleTrNoteChange = (e) => {
    setTrNote(e.target.value);
  };

  const changeNote = async () => {
    if (trNote.length > 0) {
      var body = {
        id: transaction.id,
        note: trNote,
        type: props.type,
      };

      await fetch("https://apidevkppp.ftpeople.pl/editTransactionNote", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      MySwal.fire({
        icon: "success",
        title: "Zmieniono",
        text: "notatkę do transakcji",
      }).then((result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  var trToAdd = [];
  var array = [];

  const changeIdentifier = () => {
    if (newIdentifier.length > 0) {
      setLoading(true);
      editTransaction();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const addIdentifier = () => {
    if (newIdentifier.length > 0) {
      setLoading(true);
      addTransaction();
    } else {
    }
  };

  const addTransaction = async () => {
    var pElToCheck = props.paymentsData.filter(
      (el) => el.identifier === newIdentifier
    )[0];
    if (pElToCheck !== undefined) {
      if (
        !checkValuePre(
          transaction,
          props.paymentsData.filter((el) => el.identifier === newIdentifier)[0]
        )
      ) {
        var body = {
          id: transaction.id,
          payId: newIdentifier,
          reason: "zmiana identyfikatora",
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/editTransactionNotAssignedPayId",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.text())
          .then((data) => {})
          .catch((error) => {});

        if (
          !transaction.title.includes("Wpłata w UP") &&
          !transaction.client.includes("CINKCIARZ") &&
          !transaction.title.includes("Revolut")
        ) {
          changePaymentBankAcc(transaction.bank_acc);
        }

        checkTransactions();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Transakcja przekroczy kwotę rozliczenia",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Nie ma takiego rozliczenia",
      }).then((result) => {
        props.close();
      });
    }
  };

  const changePaymentBankAcc = async (bank_acc) => {
    if (transaction.bank_acc === undefined || transaction.bank_acc === "") {
      var body = {
        id: newIdentifier,
        bank_acc: bank_acc,
      };

      await fetch("https://apidevkppp.ftpeople.pl/editPaymentBankAcc", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          return;
        })
        .catch((error) => {});
    }
  };

  const editTransaction = async () => {
    var body = {
      id: transaction.id,
      payId: newIdentifier,
    };

    await fetch("https://apidevkppp.ftpeople.pl/editTransactionPayId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return;
      })
      .catch((error) => {});
    changePaymentBankAcc(transaction.bank_acc);

    var url = "";
    if (props.type === "not_assigned") {
      url = "https://apidevkppp.ftpeople.pl/getTransactionsAssigned";
    } else {
      url = "https://apidevkppp.ftpeople.pl/getTransactionsAssigned";
    }

    MySwal.fire({
      icon: "success",
      title: "Zmieniono",
      text: "identyfikator transakcji",
    }).then((result) => {
      props.close();
    });

    return;

    var body = {};
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        checkPayments(data);
      })
      .catch((error) => {});
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkPayments = async (transactions) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data
          .filter((el) => !el.archive_date)
          .map(async (el) => {
            var transactionsForPayment = transactions.filter(
              (tr) => tr.payId === el.identifier
            );
            transactionsForPayment.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
            var pay_sum = 0;
            for (var i = 0; i < transactionsForPayment.length; i += 1) {
              pay_sum =
                parseFloat(
                  transactionsForPayment[i].bill.replaceAll(",", ".")
                ) + pay_sum;
            }

            var archive =
              parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
            var bankAcc = el.bank_acc;
            if (transactionsForPayment.length > 0) {
              if (
                !transactionsForPayment[0].title.includes("Wpłata w UP") &&
                !transactionsForPayment[0].client.includes("CINKCIARZ")
              ) {
                bankAcc = transactionsForPayment[0].bank_acc;
              }
            }

            var body2 = {
              identifier: el.identifier,
              pay_sum: pay_sum,
              bank_acc: bankAcc,
              pay_count: transactionsForPayment.length,
              pay_expected_count: checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ),
              last_pay_date:
                transactionsForPayment.length > 0
                  ? transactionsForPayment[0].date
                  : "",
              is_overdated:
                checkExpectedTransactionsCount(
                  el.first_payment_date,
                  el.installment
                ) > transactionsForPayment.length
                  ? "TAK"
                  : "NIE",
              to_archive:
                parseInt(el.to_settlement.toString().replace(",", ".")) ===
                parseInt(pay_sum.toString().replace(",", "."))
                  ? "TAK"
                  : "NIE",
              delay_time:
                archive === "TAK"
                  ? 0
                  : getDelayTime(
                      el.first_payment_date,
                      transactionsForPayment.length,
                      checkExpectedTransactionsCount(
                        el.first_payment_date,
                        el.installment
                      )
                    ),
            };

            await fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {
                return;
              })
              .catch((error) => {});
          });
      })
      .catch((error) => {});
    MySwal.fire({
      icon: "success",
      title: "Zmieniono",
      text: "identyfikator transakcji",
    }).then((result) => {
      props.close();
    });
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  const checkValue = (trEl, pEl, trToReturn) => {
    var pay_sum = pEl.pay_sum === undefined ? 0 : +pEl.pay_sum;
    for (var i = 0; i < trToAdd.length; i += 1) {
      if (trToAdd[i].id === pEl.identifier) {
        pay_sum = parseInt(trToAdd[i].bill) + pay_sum;
      }
    }
    for (var k = 0; k < trToReturn.length; k += 1) {
      pay_sum = +trToReturn[k].bill.replaceAll(",", ".") + pay_sum;
    }
    pay_sum = pay_sum + +trEl.bill.replaceAll(",", ".");
    var bool = true;

    if (+pay_sum > +pEl.to_settlement) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkValuePre = (trEl, pEl) => {
    var pay_sum = pEl.pay_sum === undefined ? 0 : +pEl.pay_sum;

    pay_sum = pay_sum + +trEl.bill.replaceAll(",", ".");
    var bool = true;

    if (+pay_sum > +pEl.to_settlement) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkTransactions = async () => {
    var counter = 0;
    setInterval(async () => {
      if (counter === 0) {
        if (props.type === "assigned") {
          var body = {};
          await fetch(
            "https://apidevkppp.ftpeople.pl/getTransactionsAssigned",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              array = data;
            })
            .catch((error) => {});
        } else {
          var body = {};
          await fetch(
            "https://apidevkppp.ftpeople.pl/getTransactionsNotAssigned",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              array = data;
            })
            .catch((error) => {});
        }
        if (array.length > 0) {
          counter++;
          checkTransactionsFinal();
        }
      }
    }, 1000);
  };

  const checkIfDoubleName = (pEl, paymentsData) => {
    var data = paymentsData.filter(
      (el) => el.name.replaceAll(",", "") === pEl.name.replaceAll(",", "")
    );
    var bool = true;
    if (data.length > 1) {
      bool = false;
    }
    return bool;
  };

  const checkTransactionsFinal = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        data
          .filter((el) => !el.archive_date)
          .map((el) => {
            var tr = getTransactionsID(el);
            if (tr.length > 0) {
              trToAdd = trToAdd.concat(tr);
            }
          });
        data
          .filter((el) => !el.archive_date)
          .map((el) => {
            var tr = getTransactionsName(el);
            if (tr.length > 0) {
              trToAdd = trToAdd.concat(tr);
            }
          });

        trToAdd.map(async (el) => {
          var body = {
            date: el.date,
            client: el.client,
            title: el.title,
            bank_acc: el.bank_acc,
            tr_id: el.tr_id,
            bank: el.bank,
            bill: el.bill,
            payId: el.payId,
            reason: el.reason,
            assign_date: el.assign_date,
            checked: el.checked,
            note: el.note,
          };

          await fetch(
            "https://apidevkppp.ftpeople.pl/insertTransactionsAssigned",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            }
          )
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});

          var body2 = {
            tr_id: el.tr_id,
          };

          await fetch(
            "https://apidevkppp.ftpeople.pl/deleteTransactionNotAssigned",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            }
          )
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});
        });

        MySwal.fire({
          icon: "success",
          title: "Zmieniono",
          text: "identyfikator transakcji",
        }).then((result) => {
          props.close();
        });

        return;

        var body = {};
        await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            checkPayments(data);
          })
          .catch((error) => {});
      })
      .catch((error) => {});
  };

  const getTransactionsID = (pEl) => {
    var trToReturn = [];
    array.map((el) => {
      var exist = checkIfTransactionExist(el);
      var value = checkValue(el, pEl, trToReturn);
      if (checkTransactionIdentifier(el, pEl.identifier) && !exist) {
        if (!value) {
          var data = {
            date: el.date,
            client: el.client,
            title: el.title,
            bank_acc: el.bank_acc,
            tr_id: el.tr_id,
            bank: el.bank,
            bill: el.bill,
            payId: pEl.identifier,
            reason: el.reason === undefined ? "identyfikator" : el.reason,
            assign_date: el.assign_date,
            checked: el.checked,
            note: el.note,
          };
          trToReturn.push(data);
        }
      }
    });
    return trToReturn;
  };

  const getTransactionsName = (pEl) => {
    var trToReturn = [];
    array.map((el) => {
      var name = checkName(el.client, pEl.name);
      var bank = false;
      if (pEl.identifier.toString().toLowerCase().includes("kzp")) {
        bank = checkBankAcc(el.accountNumber, pEl.bank_acc);
      }
      var title = checkTitle(el.title, pEl.name);
      var exist = checkIfTransactionExist(el);
      var value = checkValue(el, pEl, trToReturn);
      if ((name || title || bank) && !exist) {
        if (!value) {
          var data = {
            date: el.date,
            client: el.client,
            title: el.title,
            bank_acc: el.bank_acc,
            tr_id: el.tr_id,
            bank: el.bank,
            bill: el.bill,
            payId: pEl.identifier,
            reason:
              el.reason === undefined
                ? bank
                  ? "numer konta bankowego"
                  : name
                  ? "nazwa nadawcy"
                  : title
                  ? "tytuł przelewu"
                  : ""
                : el.reason,
            assign_date: el.assign_date,
            checked: el.checked,
            note: el.note,
          };
          trToReturn.push(data);
        }
      }
    });
    return trToReturn;
  };

  const checkTitle = (titleTr, nameP) => {
    var set1 = nameP.split(" ");
    var set2 = titleTr.split(" ");

    var bool = false;
    var matchName = false;
    var matchSurname = false;
    for (var i = 0; i < set1.length; i = i + 2) {
      for (var k = 0; k < set2.length; k++) {
        if (
          set1[i].toString().replaceAll(",", "").toLowerCase() ===
          set2[k]
            .toString()
            .replaceAll(",", "")
            .replaceAll(".", "")
            .toLowerCase()
        ) {
          matchName = true;
        }
      }
    }
    for (var o = 1; o < set1.length; o = o + 2) {
      for (var m = 0; m < set2.length; m++) {
        if (
          set1[o].toString().replaceAll(",", "").toLowerCase() ===
          set2[m]
            .toString()
            .replaceAll(",", "")
            .replaceAll(".", "")
            .toLowerCase()
        ) {
          matchSurname = true;
        }
      }
    }
    if (matchName && matchSurname) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkNamePayments = (nameP) => {
    var check = props.paymentsData.filter((el) => el.name === nameP);
    if (check.length > 1) {
      return true;
    } else {
      return false;
    }
  };

  const checkName = (nameTr, nameP) => {
    var set1 = nameP.split(" ");
    var set2 = nameTr.split(" ");

    var bool = false;
    var matchName = false;
    var matchSurname = false;
    for (var i = 0; i < set1.length; i = i + 2) {
      for (var k = 0; k < set2.length; k++) {
        if (
          set1[i].toString().replaceAll(",", "").toLowerCase() ===
          set2[k].toString().replaceAll(",", "").toLowerCase()
        ) {
          matchName = true;
        }
      }
    }
    for (var o = 1; o < set1.length; o = o + 2) {
      for (var m = 0; m < set2.length; m++) {
        if (
          set1[o].toString().replaceAll(",", "").toLowerCase() ===
          set2[m].toString().replaceAll(",", "").toLowerCase()
        ) {
          matchSurname = true;
        }
      }
    }
    if (matchName && matchSurname) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkBankAcc = (bankTr, bankP) => {
    var bool = false;

    if (bankTr === bankP) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkTransactionIdentifier = (tr, id) => {
    var setTr = tr.title.toString().split(" ");
    var bool = false;

    setTr.map((el1) => {
      if (
        (el1
          .toString()
          .replaceAll(",", "")
          .replaceAll(".", "")
          .toLowerCase() === id.toString().toLowerCase() &&
          !checkIfTransactionExist(tr)) ||
        (tr.payId === id && !checkIfTransactionExist(tr))
      ) {
        bool = true;
      }
    });

    return bool;
  };

  const checkIfTransactionExist = (trEl) => {
    //var check = transactionsData.filter(el => el.tr_id === trEl.tr_id);
    //var check2 = trToAdd.filter(el => el.tr_id === trEl.tr_id);
    //if(check.length > 0 || check2.length > 0){
    //  return true;
    //}else{
    //  return false;
    //}
    return false;
  };

  return (
    <>
      <div className="mainContainerChangeTransaction">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            Transakcja: {transaction.tr_id}
            <div className="trFaFlexBox">
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div className="inputCol_1">
                    <label>Nowy identyfikator</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={newIdentifier}
                      onChange={handleIdentifierChange}
                    />
                  </div>
                </div>
                <div className="saveBoxAP">
                  <button
                    className="paymentMenuButton"
                    onClick={
                      props.type === "assigned"
                        ? changeIdentifier
                        : addIdentifier
                    }
                  >
                    zmień identyfikator
                  </button>
                </div>
              </div>
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div className="inputCol_1">
                    <label>Notatka</label>
                    <textarea
                      spellCheck="false"
                      className="textAreaNote"
                      type="text"
                      id="url"
                      name="url"
                      value={trNote}
                      onChange={handleTrNoteChange}
                    />
                  </div>
                </div>
                <div className="saveBoxAP">
                  <button className="paymentMenuButton" onClick={changeNote}>
                    zmień notatkę
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ChangeTransactionIdentifier;
